import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const pet_type = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('pet_type')]:
        BaseSchema_PetHealthV1GetsafeDe.shape.pet_type,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_type.title',
          values: {
            pet_name: {
              type: 'dynamicValue',
              path: params.helperFunctions.getParamPath('pet_name'),
            },
          },
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('pet_type'),
        options: [
          {
            value: 'cat',
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_type.cat',
            },
          },
          {
            value: 'dog',
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.pet_type.dog',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'pure_breed',
  }) as const satisfies AnyStepConfiguration

export default pet_type
